import React from 'react'
import { Link } from 'react-router-dom';

export const SupplierTable = ({tableData, inventory, handleDelete}) => {
    return (
        <table className="table table-hover text-nowrap">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Contact Person</th>
                    <th>Contact No.</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {tableData.map((data, key) => <tr>
                        <td><Link to={`/inventory/${inventory}/${data.id}/edit`}>{data.name ? data.name : '-'}</Link></td>
                        <td>{data.address}</td>
                        <td>{data.contact_person}</td>
                        <td>{data.contact_no}</td>
                        <td>
                            <button className="btn btn-tool" onClick={()=> {
                                if (window.confirm('Are you sure you want to delete?')) {
                                    handleDelete(data.id)
                                }
                            }}>
                                <i className="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>)}
            </tbody>
        </table>
    )
}
